/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import { Button, ButtonToolbar, Modal, Input } from 'reactstrap';

const MakeCall = ({ phone, toggle, visible }) => {
  const [number, setNumber] = useState('');

  useEffect(() => {
    if (phone) {
      setNumber(phone.number);
    }
  }, [phone]);

  const updateNumber = (e) => {
    setNumber(e.target.value);
  };

  return (
    <Modal className="modal-dialog--primary" isOpen={visible} toggle={toggle()}>
      <div className="modal__header">
        <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle()} />
        <h2 className="bold-text modal__title label-autofin" style={{ marginBottom: '20px' }}>Llamar</h2>
      </div>
      <div className="modal__body">
        {phone && (
          <Input type="text" name="number" onChange={updateNumber} value={number} />
        )}
      </div>
      <ButtonToolbar className="modal__footer">
        <Button className="asignar" color="secondary" onClick={toggle()}>Cancelar</Button>{' '}
        <Button className="call-button" color="success" disabled={!number && number.length < 8} onClick={toggle(number)}>Aceptar</Button>
      </ButtonToolbar>
    </Modal>
  );
};

export default MakeCall;
